
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FilterContainer extends Vue {
    displayFilters = false;

    toggleFilters() {
        this.displayFilters = !this.displayFilters;
    }
}
